import {faCheck, faTimes} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import LinkCandidateProfile from 'components/LinkCandidateProfile';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import RatingInformationPopup from '../RatingInformationPopup';

const RatingInformationItem = props => {
  const { record, user } = props;
  const {
    CandidateID,
    FullName,
    Rate,
    RateDate,
    Met,
    Spoke,
    RatingNotes,
  } = record;

  const excerpt = [...(RatingNotes.substring(0, 70) + '... ')];
  const [showMore, setShowMore] = useState(false);

  return (
    <div
      className="sidebar__table-row rating-information__row"
      style={{
        flexDirection: 'column',
      }}
    >
      <div className="sidebar__table-row-inner">
        <div className="sidebar__table-column">
          {CandidateID ? (
            <LinkCandidateProfile
              cls="rating-information__name"
              user={user}
              id={CandidateID}
              name={FullName}
              viewProfile={true}
            />
          ) : (
            <strong>{record.FullName}</strong>
          )}
        </div>
        <div
          className="sidebar__table-column"
          style={{
            flex: '1 1 60px',
            textAlign: 'center',
          }}
        >
          <div className="rating-information__rating">{Rate}</div>
        </div>
        <div
          className="sidebar__table-column"
          style={{
            flex: '1 1 50px',
          }}
        >
          <div className="rating-information__date">{RateDate}</div>
        </div>
      </div>

      <ul className="rating-information__checklist">
        <li className="rating-information__check">
          <span className="rating-information__icon">
            {Number(Met) === 1 ? (
              <FontAwesomeIcon icon={faCheck} color="#f40" size="lg" />
            ) : (
              <FontAwesomeIcon icon={faTimes} color="#27282d" size="lg" />
            )}
          </span>

          <span className="rating-information__value">Met candidate</span>
        </li>
        <li className="rating-information__check">
          <span className="rating-information__icon">
            {Number(Spoke) === 1 ? (
              <FontAwesomeIcon icon={faCheck} color="#f40" size="lg" />
            ) : (
              <FontAwesomeIcon icon={faTimes} color="#27282d" size="lg" />
            )}
          </span>
          <span className="rating-information__value">Spoke to Candidate</span>
        </li>
      </ul>

      {RatingNotes && (
        <div className="rating-information__text">
          {excerpt}
          <button type={'button'} className={'show-more__button'} onClick={() => setShowMore(true)}>Show more</button>
        </div>
      )}
      <RatingInformationPopup data={record} user={user} show={showMore} onClose={setShowMore} />
    </div>
  );
};

RatingInformationItem.propTypes = {
  record: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

export default RatingInformationItem;
